import styled from "styled-components";

export const Styles = styled.div`
  .header-icon-filter {
    cursor: pointer;
    background-color: transparent;
    border: none !important;
    outline: none !important;
  }
  .header-icon-filter:hover {
    background-color: transparent;
    border: none !important;
    outline: none !important;
  }
  .header-icon-filter.disabled,
  .header-icon-filter.disabled:hover {
    cursor: not-allowed;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
`;
